import axios from "axios";
import moment from "moment";
import { useState, useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";

const LastBuildDate = () => {
  const [buildDate, setBuildDate] = useState("");

  useEffect(() => {
    axios("/build-date.json").then((res) => {
      const formattedDate =
        moment
          .utc(res.data.DateTime, "ddd MMM DD HH:mm:ss YYYY")
          .format("YYYY-MM-DD HH:mm:ss") + " UTC+0";

      setBuildDate(formattedDate);
    });
  }, []);

  return (
    <div className="body">
      <Header />

      <div className="last-build">
        <h1 className="main-title">Last Build Date:</h1>
        <p className="last-build__date">{buildDate}</p>
      </div>

      <Footer />
    </div>
  );
};

export default LastBuildDate;
